// extracted by mini-css-extract-plugin
export default {"menu_item_value":"PageMenu_menu_item_value__2Aw5i","menu_item_desc":"PageMenu_menu_item_desc__gsVy-"};